<template>
  <section 
    class="advantages" 
    id="advantages"
    :style="{ backgroundImage: 'url(' + bgImage + ')' }"
  >
    <!-- 添加一个遮罩层，让文字更清晰 -->
    <div class="overlay"></div>
    
    <div class="container">
      <div class="section-title">
        <h2>合作优势</h2>
        <p>携手共赢，共建智慧教育新生态</p>
      </div>
      
      <div class="adv-content">
        <div class="adv-list">
          <div class="adv-item" v-for="item in advantages" :key="item.id">
            <h4>
              <img :src="item.icon" alt="" class="adv-icon">
              {{ item.title }}
            </h4>
            <p>{{ item.desc }}</p>
          </div>
        </div>
        <!-- 这里不再需要右侧的 img 标签，因为已经是背景了 -->
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AppAdvantages',
  data() {
    return {
      // 引入背景图
      bgImage: require('../assets/placeholder-img.png'),
      advantages: [
        { 
          id: 1, 
          title: '优质产品矩阵', 
          desc: '成熟稳定的产品体系，满足多样化校园场景',
          icon:  require('../assets/check-icon.png')
        },
        { 
          id: 2, 
          title: '灵活合作模式', 
          desc: '灵活合作政策，支持项目合作与区域深耕',
          icon:  require('../assets/check-icon.png') 
        },
        { 
          id: 3, 
          title: '全方位赋能支持', 
          desc: '产品培训、方案支持、技术支持',
          icon:  require('../assets/check-icon.png') 
        },
        { 
          id: 4, 
          title: '长久共赢生态', 
          desc: '完善分润体系，携手共创智慧未来',
          icon:  require('../assets/check-icon.png')
        }
      ]
    }
  }
}
</script>

<style scoped>
.advantages {
  position: relative;
  padding: 100px 0; /* 增加上下内边距，显得更大气 */
  background-color: #0f172a; /* 兜底背景色，防止图片加载失败 */
  
  /* 背景图设置：铺满、靠右显示（为了露出广州塔）、不重复 */
  background-size: cover;
  background-position: center right; 
  background-repeat: no-repeat;
}

/* 新增：遮罩层，压暗背景，突出文字 */
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /* 使用线性渐变：左边深黑（为了文字清晰），右边稍透（为了看风景） */
  /* background: linear-gradient(to right, rgba(15, 23, 42, 0.95) 0%, rgba(15, 23, 42, 0.7) 50%, rgba(15, 23, 42, 0.3) 100%); */
  z-index: 1;
}

.container {
  position: relative;
  z-index: 2; /* 确保内容在遮罩层之上 */
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.section-title {
  text-align: center; /* 或者改为 text-align: left 如果你想左对齐 */
  margin-bottom: 60px;
}

.section-title h2 {
  font-size: 36px;
  color: #ffffff; /* 改为白色 */
  margin-bottom: 15px;
  font-weight: bold;
  letter-spacing: 2px;
}

.section-title p {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.7); /* 改为半透明白色 */
  letter-spacing: 1px;
}

.adv-content {
  display: flex;
  align-items: center;
  /* 限制宽度，让列表不要铺太满，给右侧背景图留空间 */
  max-width: 600px; 
 
  margin: 0; 
}

.adv-list {
  width: 100%;
}

.adv-item {
  margin-bottom: 35px;
  /* 添加一点左侧边框或背景块可以让列表更精致，这里保持简洁 */
}

.adv-item h4 {
  font-size: 20px;
  color: #ffffff; /* 改为白色 */
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 12px;
  font-weight: 600;
}

/* 图标变白处理 */
.adv-icon {
  width: 24px;
  height: 24px;
  object-fit: contain;
  /* 关键：如果原图标是黑色的，用这个滤镜把它变白 */
  filter: brightness(0) invert(1); 
}

.adv-item p {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6); /* 改为浅灰色/半透明白 */
  line-height: 1.6;
  padding-left: 36px; /* 对齐文字 */
}

/* 响应式调整 */
@media (max-width: 768px) {
  .advantages {
    background-position: center center; /* 手机端居中显示背景 */
  }
  .overlay {
    background: rgba(15, 23, 42, 0.85); /* 手机端整体压暗 */
  }
  .adv-content {
    max-width: 100%;
  }
}
</style>